import { render, staticRenderFns } from "./SingSynchro.vue?vue&type=template&id=50bfa904&scoped=true"
import script from "./SingSynchro.vue?vue&type=script&lang=js"
export * from "./SingSynchro.vue?vue&type=script&lang=js"
import style0 from "./SingSynchro.vue?vue&type=style&index=0&id=50bfa904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bfa904",
  null
  
)

export default component.exports